import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {
  ControlContainer,
  NgForm
} from '@angular/forms';

@Component({
  selector   : 'wor-text-control',
  styles: [ require('./text-control.component.scss') ],
  template: require('./text-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class TextControlComponent implements AfterViewInit {
  @Input() autocomplete   ?: string  = 'one-time-code';
  @Input() giveFocus      ?: boolean = false;
  @Input() hint           ?: string;
  @Input() isClearable     = false;
  @Input() label          ?: string;
  @Input() labelNote      ?: string;
  @Input() lengthWarning  ?: number;
  @Input() max            ?: number | string;
  @Input() maxlength       = 255;
  @Input() min            ?: number;
  @Input() name           : string;
  @Input() placeholder    ?: string = '';
  @Input() showHint        = false;
  @Input() type            = 'text'
  @Input() warningMessage ?: string;

  _model    : any;
  _disabled : boolean;
  _required : boolean;

  /**
   * if these flags are present in the html
   * but not set to any value then their value will
   * be an empty string. If that's the case, set an
   * internal variable to true here.
   */
  @Input() set disabled ( _disabled : string | boolean ) {
    this._disabled = _disabled === '' || !!_disabled;
  }

  @Input() set model ( _model : any ) {
    this._model = _model;
  };

  @Input() set required ( _required : string | boolean ) {
    this._required = _required === '' || !!_required;
  }

  @Output() blur       : EventEmitter<Event> = new EventEmitter();
  @Output() clear      : EventEmitter<void>  = new EventEmitter();
  @Output() focus      : EventEmitter<Event> = new EventEmitter();
  @Output() modelChange: EventEmitter<any>   = new EventEmitter();

  @ViewChild('elementRef') elementRef : ElementRef;

  ngAfterViewInit () : void {
    if (this.giveFocus) {
      this.elementRef?.nativeElement?.focus();
    }
  }

  handleBoundedModelChange () : void {
    const value = parseFloat(this._model);

    // Force the input value so the clamp shows even when it equals the current model.
    if ( this.max != null && value > +this.max ) {
      this._model                         = +this.max;
      this.elementRef.nativeElement.value = +this.max;
    }
    else if ( this.min != null && value < this.min ) {
      this._model                         = this.min;
      this.elementRef.nativeElement.value = this.min;
    }

    this.modelChange.emit(this._model);
  }

  // Clears the input when isClearable is enabled and the user clicks the
  // clear button. Updates the model + emits modelChange so two-way bindings
  // stay in sync, and emits clear so consumers can react to an explicit
  // clear (e.g. re-run a manual search).
  handleClear () : void {
    this._model = '';
    this.modelChange.emit('');
    this.clear.emit();
  }

  
}
